import { Hero } from "@/components/home/Hero";
import { Marquee } from "@/components/home/Marquee";
import { SelectionEngine } from "@/components/home/SelectionEngine";
import { SwapPreview } from "@/components/home/SwapPreview";
import { LatestSignals } from "@/components/home/LatestSignals";
import { TelegramAlerts } from "@/components/home/TelegramAlerts";

export default function Home() {
  return (
    <div data-testid="home-page">
      <Hero />
      <Marquee />
      <SelectionEngine />
      <SwapPreview />
      <LatestSignals />
      <TelegramAlerts />
    </div>
  );
}
